module.exports = __webpack_public_path__ + "img/progress-bg.ce6da337.png";